import React from 'react';
import { useTranslation } from 'react-i18next';

import Select from '../../common/data-entry/Select/Select';
import { NS_COMMON } from '../../services/i18n/namespaces';

export function SSUFilterMaterialRepresentation({
  studies,
  sites,
  handleSiteChange,
  handleStudyChange,
  initialStudy,
  initialSite,
  isStudyRequired,
  isSiteRequired,
  selectorClass = '',
  studyValidationMessage,
  siteValidationMessage
}) {
  const { t } = useTranslation();
  return (
    <>
      <Select
        label={t(`${NS_COMMON}:study`)}
        searchable
        clearSearchOnSelection
        onChange={handleStudyChange}
        dataSource={studies}
        optionLabelKey="studyName"
        optionValueKey="uniqueIdentifier"
        value={initialStudy}
        valid={isStudyRequired}
        validationMessage={studyValidationMessage}
        required
        data-testid="study-selector"
      />
      <Select
        label={t(`${NS_COMMON}:site`)}
        searchable
        clearSearchOnSelection
        onChange={handleSiteChange}
        optionLabelKey="siteName"
        optionValueKey="uniqueIdentifier"
        dataSource={sites}
        value={initialSite}
        valid={isSiteRequired}
        validationMessage={siteValidationMessage}
        required
        data-testid="site-selector"
      />{' '}
    </>
  );
}
